/* istanbul ignore file */
/**
 * Tabs and tab view component theme configurations.
 */

export const tabsComponentConfig = {
  tabs: {
    root: {
      transitionDuration: '{transition.duration}',
    },
    tablist: {
      borderWidth: '0',
      background: '{content.background}',
      borderColor: '{greymatter.100}',
    },
    tab: {
      background: 'none',
      hoverBackground: 'none',
      activeBackground: '{primary.contrastColor}',
      borderWidth: '0 0 1px 0',
      borderColor: '{greymatter.100}',
      hoverBorderColor: '{primary.color}',
      activeBorderColor: '{primary.color}',
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
      activeColor: '{neutral.1000}',
      padding: '8px 12px',
      fontWeight: '400',
      margin: '0',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '-2px',
        shadow: '{focus.ring.shadow}',
      },
    },
    tabpanel: {
      background: '{content.background}',
      color: '{content.color}',
      padding: '0.875rem 1.125rem 1.125rem 1.125rem',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: 'inset {focus.ring.shadow}',
      },
    },
    navButton: {
      background: '{content.background}',
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
      width: '2.5rem',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: 'inset {focus.ring.shadow}',
      },
    },
    activeBar: {
      height: '0',
      bottom: '0',
      background: 'transparent',
    },
    colorScheme: {
      light: {
        navButton: {
          shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
        },
      },
      dark: {
        navButton: {
          shadow: '0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)',
        },
      },
    },
  },
};

export const tabViewComponentConfig = {
  tabview: {
    root: {
      transitionDuration: '{transition.duration}',
    },
    tabList: {
      background: '{content.background}',
      borderColor: '{content.border.color}',
    },
    tab: {
      borderColor: '{content.border.color}',
      activeBorderColor: '{primary.color}',
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
      activeColor: '{primary.color}',
    },
    tabPanel: {
      background: '{content.background}',
      color: '{content.color}',
    },
    navButton: {
      background: '{content.background}',
      color: '{text.muted.color}',
      hoverColor: '{text.color}',
    },
    colorScheme: {
      light: {
        navButton: {
          shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
        },
      },
      dark: {
        navButton: {
          shadow: '0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)',
        },
      },
    },
  },
};
